import { FilterSection } from '../../product-filters/components/sections/filter-section'
import { Radio, RadioGroup } from 'components/forms'

interface SortControlsProps {
  isOpen?: boolean
  onSortChange: (sortValue: string) => void
  selectedSort?: string
}

const SORT_OPTIONS = [
  { label: 'Popular', value: '' }, // default sort, no value required
  { label: 'Newest', value: 'newest' },
  { label: 'Price: High to Low', value: 'price_desc' },
  { label: 'Price: Low to High', value: 'price_asc' },
  { label: 'Highest Rated', value: 'highest_rated' },
  { label: 'Most Reviewed', value: 'most_reviewed' },
]

export const SortControls = ({
  isOpen = false,
  onSortChange,
  selectedSort,
}: SortControlsProps) => {
  return (
    <FilterSection open={isOpen} title="Sort by">
      <RadioGroup>
        {SORT_OPTIONS.map((option) => {
          return (
            <Radio
              name="sort"
              size="large"
              key={option.value}
              label={option.label}
              value={option.value}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                onSortChange(e.target.value)
              }
              defaultChecked={selectedSort === option.value}
            />
          )
        })}
      </RadioGroup>
    </FilterSection>
  )
}
